var cloneSvg = function (sourceSvg) {
    return sourceSvg.cloneNode(true);
};
export default cloneSvg;
//# sourceMappingURL=clone-svg.js.map